export default __webpack_public_path__ + "static/media/landing_background.440a66a0.jpg";